export const PlusIcon = ({ color }: { color?: string }) => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill={color ? color : "white"} d="M4.81756 3.084H7.52156V4.716H4.81756V7.42H3.18556V4.716H0.481563V3.084H3.18556V0.379999H4.81756V3.084Z" />
  </svg>
);
